import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Alert, Link, Button } from '@gsa/afp-component-library';
import MarkUpText from '@/components/MarkUpText/MarkUpText';
import Modal from '@/components/Modal/Modal';
import {
  getInactiveAlertMsg,
  getInactiveLinkText,
  getInactiveSIArray,
} from './inactive-si-utils';
import InactiveSITable from './inactive-si-table';

const InactiveSIAlert = ({ solicitationPrograms, contractYear }) => {
  const [inactiveSins, setInactiveSins] = useState([]);
  const [linkText, setLinkText] = useState('');
  const [alertMsg, setAlertMsg] = useState('');
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const inactiveSIArray = getInactiveSIArray(solicitationPrograms);
    setInactiveSins(inactiveSIArray);

    if (inactiveSIArray.length === 0) {
      setLinkText('');
      setAlertMsg('');
    } else {
      setLinkText(getInactiveLinkText(inactiveSIArray?.length));
      setAlertMsg(getInactiveAlertMsg(inactiveSIArray?.length));
    }
  }, [solicitationPrograms]);

  if (!linkText) return null;

  return (
    <>
      <Alert type="warning" slim className="margin-bottom-2">
        <MarkUpText
          content={alertMsg}
          marker={Link}
          textToMarkUp={linkText}
          markerProps={{
            onClick: () => {
              setShowModal(true);
            },
          }}
        />
      </Alert>
      <Modal
        title={
          <div className="margin-top-5" aria-label="Inactive Standard Items">
            <h3>Inactive Standard Items</h3>
          </div>
        }
        actions={
          <Button
            className="padding-right-1"
            aria-label="Cancel"
            variant="unstyled"
            onClick={() => {
              setShowModal(false);
            }}
            data-testid="invalid-si-cancel-btn"
            label="Close"
          />
        }
        show={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        <InactiveSITable
          inactiveSins={inactiveSins}
          contractYear={contractYear}
        />
      </Modal>
    </>
  );
};

InactiveSIAlert.propTypes = {
  solicitationPrograms: PropTypes.arrayOf(
    PropTypes.shape({
      program: PropTypes.string,
      solicitationLines: PropTypes.arrayOf(
        PropTypes.shape({
          standardItemId: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
          ]),
          standardItem: PropTypes.shape({
            standardItemNumber: PropTypes.string,
            title: PropTypes.string,
            vehicleType: PropTypes.string,
            isActive: PropTypes.number,
          }),
        }),
      ),
    }),
  ),
  contractYear: PropTypes.number.isRequired,
};

export default InactiveSIAlert;
